<script>
  export let item;
  let opened = item.active || item.alwaysOpened;
</script>

{#if item.submenu}
  <button class="MenuItem {item.active ? 'Active': ''}"
    data-icon-before="{item.icon}"
    data-icon-after="{ item.iconAfter || `keyboard_arrow_${  opened ? 'up' : 'down'}` }"
    on:click={() => opened = !opened}>{item.label}</button>

    <div class="Menu {opened ? '' : 'Closed'}">
      {#each item.submenu as subitem}
        <button class="MenuItem {subitem.active ? 'Active': ''} SubMenuItem"
          data-icon-before="{subitem.icon}"
          data-icon-after="{subitem.iconAfter}"
          on:click={() => subitem.action()}>{subitem.label}</button>
      {/each}
    </div>
{:else}
  <button class="MenuItem {item.active ? 'Active': ''}"
    data-icon-before="{item.icon}"
    data-icon-after="{item.iconAfter}"
    on:click={() => item.action()}>{item.label}</button>
{/if}

<style lang="stylus">
  @import './styles.blocks.styl'

  .MenuItem {
    {MenuItem}
    height: 36px;
    opacity: 0.7;
    padding: 0 14px 0 32px;

    &:before {
      margin-right: 10px;
      font-size: 20px;
    }

    &:after {
      font-size: 20px;
    }

    &:hover {
      opacity: .8;
    }

    &.Active {
      background : #313C42;
      opacity: 1;

      &:before {
        color: #00B8AB;
      }

      &:hover {
        opacity: 1;
      }
    }
  }

  .SubMenuItem {
    padding-left: 60px;
    font-size: 12px;
    height: 35px;
  }

  .Closed {
    max-height: 0;
    overflow: hidden;
  }
</style>
